import { UserCollectionItemsMoleculeReatom as UserCollectionItemsMolecule } from "@/app/collections/items/user-items/store/user-collection-items-molecule.reatom"
import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import type { NftMiniature } from "@anaconda/core/nft/types"
import { useInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"

export const useTableItems = () => {
  const { allUserCollectionItemsQueryParams } = useMolecule(
    UserCollectionItemsMolecule,
  )
  const queryParams = allUserCollectionItemsQueryParams()
  const query = useInfiniteQuery(queryParams)

  // Transform the API response structure to match what useInfiniteTableItems expects
  // API returns: { nfts: NftMiniature[], continuation, totalNftsCount }
  // useInfiniteTableItems expects: { items: NftMiniature[] }[]
  const transformedQuery = useMemo(() => {
    if (!query.data) {
      return {
        pages: [],
        hasNextPage: query.hasNextPage,
        isFetchingNextPage: query.isFetchingNextPage,
        fetchNextPage: query.fetchNextPage,
      }
    }

    return {
      pages: query.data.pages.map((page) => ({
        items: page.nfts,
      })),
      hasNextPage: query.hasNextPage,
      isFetchingNextPage: query.isFetchingNextPage,
      fetchNextPage: query.fetchNextPage,
    }
  }, [
    query.data,
    query.hasNextPage,
    query.isFetchingNextPage,
    query.fetchNextPage,
  ])

  return useInfiniteTableItems<NftMiniature>(transformedQuery)
}
